import script from "./buy_detail.vue?vue&type=script&setup=true&lang=js"
export * from "./buy_detail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__